import StatusMoreDetailsLink from 'Components/Atoms/A_VViewer/StatusMoreDetailsLink';
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

export default function CustomizedDialogsMovil({ open, handleClose, volcanoLevels }) {

  return (
      <Dialog onClose={handleClose} aria-labelledby="activity-levels" open={open}>
        <DialogTitle sx={{ fontSize: 18 }} id="activity-levels">
          Estados de alerta volcánica
          <StatusMoreDetailsLink />
          <IconButton aria-label="close" onClick={handleClose} 
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className="m-dialog-content">
          <div className="m-table-content">
            <div className="m-table-row">
               {
                  volcanoLevels?.map((level)=>(
                     <div key={ level.index_number } className="m-item-content">
                        <div className="m-head-table">
                           <p>Estado de alerta</p>
                        </div>
                        <div className="m-content-table">
                           <div className="m-state-activity">
                              <img alt="level" src={ level.icon } />
                              <p className="title">{ level.title }</p>
                           </div>
                           <p>Estado de alerta: <span>{ level.short_description }</span></p>
                           <p>Descripción técnica: <span>{ level.description }</span></p>
                        </div>
                     </div>
                  ))
               }
            </div>
            </div>
        </DialogContent>
      </Dialog>
  );
}
